const DOCUMENT = 'AGENCIES_INVITE_';

const actions = {
  LOAD_REQUEST: DOCUMENT + 'LOAD_REQUEST',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  LOAD_ERROR: DOCUMENT + 'LOAD_ERROR',
  REINVITE_ACTION_REQUEST: DOCUMENT + 'REINVITE_ACTION_REQUEST',
  REINVITE_ACTION_SUCCESS: DOCUMENT + 'REINVITE_ACTION_SUCCESS',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',

  loadData: data => ({ type: actions.LOAD_REQUEST, payload: data }),

  loadDataSuccess: data => ({ type: actions.LOAD_SUCCESS, payload: data }),

  loadDataError: () => ({ type: actions.LOAD_ERROR }),

  reinviteAction: data => ({ type: actions.REINVITE_ACTION_REQUEST, payload: data }),

  reinviteActionSuccess: data => ({ type: actions.REINVITE_ACTION_SUCCESS, payload: data }),

  clearStore: () => ({ type: actions.CLEAR_STORE }),
};

export default actions;
